import { render, staticRenderFns } from "./HistoryQuota.vue?vue&type=template&id=479fd821&"
import script from "./HistoryQuota.vue?vue&type=script&lang=js&"
export * from "./HistoryQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports